
export type UpdateUserProfileBodyPreferencesTheme = typeof UpdateUserProfileBodyPreferencesTheme[keyof typeof UpdateUserProfileBodyPreferencesTheme];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateUserProfileBodyPreferencesTheme = {
  light: 'light',
  dark: 'dark',
  auto: 'auto',
} as const;
